export const keyCodes = {
    13: 'enter',
    27: 'escape',
    38: 'up',
    40: 'down',
};

export const isPrintableKeyCode = keyCode => keyCode > 47 && keyCode < 58 || // number keys
keyCode === 32 || // spacebar
keyCode === 8 || // backspace
keyCode > 64 && keyCode < 91 || // letter keys
keyCode > 95 && keyCode < 112 || // numpad keys
keyCode > 185 && keyCode < 193 || // ;=,-./` (in order)
keyCode > 218 && keyCode < 223; // [\]' (in order)

export default {
    keyCodes: keyCodes,
    isPrintableKeyCode: isPrintableKeyCode,
};
